import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function CenturyIllustration({
  achievementId,
  variant = 'pixel',
  // Century unlocks the pixel variant, so we default to it
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3399">
      <div className="relative w-full h-full bg-gradient-to-br from-emerald-100 to-teal-200 overflow-hidden" data-id="element-3400">
        {/* Background: Sunburst */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3401">
          <g className="origin-center animate-[spin_20s_linear_infinite]" style={{
          transformOrigin: '100px 100px'
        }} data-id="element-3402">
            {[...Array(12)].map((_, i) => <path key={i} d="M100 100 L90 -20 L110 -20 Z" fill="#34D399" fillOpacity="0.3" transform={`rotate(${i * 30} 100 100)`} data-id="element-3403" />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[10%]" data-id="element-3404">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3405">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} variant={variant} accessory="badge100" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3406" />
          </div>
        </div>

        {/* Foreground: Banners and 100s */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3407">
            <path d="M-10 30 Q100 60 210 30 L210 45 Q100 75 -10 45 Z" fill="#EF4444" data-id="element-3408" />
            <path d="M-10 35 Q100 65 210 35 L210 40 Q100 70 -10 40 Z" fill="#FCA5A5" data-id="element-3409" />

            <text x="30" y="45" fontFamily="sans-serif" fontSize="14" fontWeight="900" fill="white" transform="rotate(10 30 45)" data-id="element-3410">
              100
            </text>
            <text x="170" y="45" fontFamily="sans-serif" fontSize="14" fontWeight="900" fill="white" transform="rotate(-10 170 45)" data-id="element-3411">
              100
            </text>

            <circle cx="40" cy="150" r="8" fill="#FBBF24" data-id="element-3412" />
            <circle cx="160" cy="160" r="12" fill="#3B82F6" data-id="element-3413" />
            <circle cx="180" cy="120" r="6" fill="#10B981" data-id="element-3414" />
            <circle cx="20" cy="110" r="10" fill="#EF4444" data-id="element-3415" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}